(function () {
  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'PHP' }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function initHeader(root) {
    root.querySelectorAll('details[data-lgb-drawer]').forEach(function (d) {
      d.addEventListener('toggle', function () {
        document.documentElement.classList.toggle('lgb-lock', d.open);
      });
      d.querySelectorAll('.lgb-drawer a').forEach(function (a) {
        a.addEventListener('click', function () { d.removeAttribute('open'); });
      });
    });
    root.querySelectorAll('[data-lgb-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var d = btn.closest('details');
        if (d) d.removeAttribute('open');
      });
    });
    document.addEventListener('click', function (e) {
      root.querySelectorAll('details[data-lgb-dd][open]').forEach(function (d) {
        if (!d.contains(e.target)) d.removeAttribute('open');
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      root.querySelectorAll('details[data-lgb-dd][open], details[data-lgb-drawer][open]').forEach(function (d) {
        d.removeAttribute('open');
        var s = d.querySelector('summary');
        if (s) s.focus();
      });
    });
  }

  function initGallery(g) {
    if (g.dataset.ready) return;
    g.dataset.ready = '1';
    var track = g.querySelector('[data-lgb-track]');
    var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-lgb-thumb]'));
    if (!track) return;
    function show(i) {
      var slide = track.children[i];
      if (!slide) return;
      track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      thumbs.forEach(function (t, n) {
        if (n === i) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
      });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { show(parseInt(t.dataset.lgbThumb, 10)); });
    });
    var natural = g.classList.contains('lgb-gallery--natural');
    var current = 0;
    function fit() {
      if (!natural) return;
      var slide = track.children[current];
      if (slide && slide.offsetHeight) track.style.height = slide.offsetHeight + 'px';
    }
    var tick = null;
    track.addEventListener('scroll', function () {
      if (tick) return;
      tick = requestAnimationFrame(function () {
        tick = null;
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i === current) return;
        current = i;
        thumbs.forEach(function (t, n) {
          if (n === i) t.setAttribute('aria-current', 'true');
          else t.removeAttribute('aria-current');
        });
        fit();
      });
    }, { passive: true });
    if (natural) {
      track.querySelectorAll('img').forEach(function (im) {
        if (!im.complete) im.addEventListener('load', fit);
      });
      window.addEventListener('resize', fit);
      fit();
    }
    g.lgbShowMedia = function (mediaId) {
      var slides = Array.prototype.slice.call(track.children);
      var i = slides.findIndex(function (s) { return String(s.dataset.mediaId) === String(mediaId); });
      if (i > -1) show(i);
    };
  }

  function initBundle(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var currency = root.dataset.currency;
    var variants = [];
    var vEl = root.querySelector('[data-lgb-variants]');
    if (vEl) {
      try { variants = JSON.parse(vEl.textContent); } catch (e) { variants = []; }
    }
    var idEl = root.querySelector('[data-lgb-variant-id]');
    var addons = Array.prototype.slice.call(root.querySelectorAll('[data-lgb-addon]'));
    var packs = Array.prototype.slice.call(root.querySelectorAll('[data-lgb-pack]'));
    var options = Array.prototype.slice.call(root.querySelectorAll('[data-lgb-option]'));
    var qty = root.querySelector('[data-lgb-qty]');
    var total = root.querySelector('[data-lgb-total]');
    var summary = root.querySelector('[data-lgb-summary]');
    var submit = root.querySelector('[data-lgb-submit]');
    var msg = root.querySelector('[data-lgb-msg]');
    var letter = root.querySelector('[data-lgb-letter]');
    var count = root.querySelector('[data-lgb-count]');
    var date = root.querySelector('[data-lgb-date]');
    var area = root.querySelector('[data-lgb-area]');
    var pdp = root.closest('[data-lgb-pdp]');
    var priceEl = pdp ? pdp.querySelector('[data-lgb-price]') : null;
    var compareEl = pdp ? pdp.querySelector('[data-lgb-compare]') : null;
    var gallery = pdp ? pdp.querySelector('[data-lgb-gallery]') : null;
    var labelAdd = root.dataset.labelAdd || 'Add to bag';

    if (date) {
      var lead = parseInt(root.dataset.lead || '1', 10);
      var d = new Date();
      d.setDate(d.getDate() + lead);
      var iso = new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
      date.min = iso;
    }

    function basePrice() { return parseInt(idEl.dataset.price, 10) || 0; }
    function qtyVal() { return Math.min(99, Math.max(1, parseInt(qty.value, 10) || 1)); }
    packs.forEach(function (p) {
      try { p.lgbItems = JSON.parse(p.dataset.lgbPackItems || '[]').filter(function (i) { return i.available !== false; }); }
      catch (e) { p.lgbItems = []; }
    });
    var active = [];
    function packIds() {
      var ids = [];
      active.forEach(function (p) { p.lgbItems.forEach(function (i) { ids.push(String(i.id)); }); });
      return ids;
    }
    function packSum(p) { return p.lgbItems.reduce(function (t, i) { return t + (parseInt(i.price, 10) || 0); }, 0); }
    function extras() {
      var ids = packIds();
      return addons.filter(function (a) { return a.checked && ids.indexOf(a.value) < 0; });
    }

    function update() {
      var ex = extras();
      var each = basePrice() + active.reduce(function (t, p) { return t + packSum(p); }, 0) + ex.reduce(function (t, a) { return t + (parseInt(a.dataset.price, 10) || 0); }, 0);
      var q = qtyVal();
      if (total) total.textContent = money(each * q, currency);
      if (summary) {
        var names = active.map(function (p) { return p.dataset.lgbPack; });
        var parts = [names.length ? (root.dataset.boxLabel || 'Gift set') + ' + ' + names.join(' + ') : (root.dataset.boxLabel || 'Gift set') + ' only'];
        if (ex.length) parts.push(ex.length + (ex.length === 1 ? ' extra' : ' extras'));
        summary.textContent = parts.join(', ') + (q > 1 ? ' × ' + q : '');
      }
      packs.forEach(function (p) {
        var on = p.dataset.lgbPack ? active.indexOf(p) > -1 : !active.length;
        p.classList.toggle('is-active', on);
        p.setAttribute('aria-pressed', on ? 'true' : 'false');
        var pp = p.querySelector('[data-lgb-pack-price]');
        if (pp) pp.textContent = p.dataset.lgbPack ? '+ ' + money(packSum(p), currency) : money(basePrice(), currency);
      });
    }

    function selectVariant() {
      if (!options.length || !variants.length) return;
      var groups = {};
      options.forEach(function (o) { if (o.checked) groups[o.dataset.lgbOption] = o.value; });
      var match = variants.find(function (v) {
        return v.options.every(function (val, i) { return groups[i] === undefined || String(val) === groups[i]; });
      });
      var tmp = document.createElement('textarea');
      if (!match) {
        match = variants.find(function (v) {
          return v.options.every(function (val, i) {
            tmp.innerHTML = groups[i] || '';
            return groups[i] === undefined || String(val) === tmp.value;
          });
        });
      }
      if (!match) {
        submit.disabled = true;
        submit.textContent = 'Unavailable';
        return;
      }
      idEl.value = match.id;
      idEl.dataset.price = match.price;
      if (priceEl) priceEl.textContent = money(match.price, currency);
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = money(match.compare_at_price, currency);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      submit.disabled = !match.available;
      submit.textContent = match.available ? labelAdd : 'Sold out';
      if (match.featured_media && gallery && gallery.lgbShowMedia) gallery.lgbShowMedia(match.featured_media.id);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
      update();
    }

    options.forEach(function (o) { o.addEventListener('change', selectVariant); });
    addons.forEach(function (a) { a.addEventListener('change', update); });
    packs.forEach(function (p) {
      p.addEventListener('click', function () {
        var before = packIds();
        if (!p.dataset.lgbPack) active = [];
        else if (active.indexOf(p) > -1) active.splice(active.indexOf(p), 1);
        else active.push(p);
        var after = packIds();
        addons.forEach(function (a) {
          if (before.indexOf(a.value) > -1 && after.indexOf(a.value) < 0) a.checked = false;
          if (after.indexOf(a.value) > -1) a.checked = true;
        });
        update();
      });
    });
    if (qty) {
      qty.addEventListener('input', update);
      qty.addEventListener('change', function () { qty.value = qtyVal(); update(); });
      var dec = root.querySelector('[data-lgb-dec]');
      var inc = root.querySelector('[data-lgb-inc]');
      if (dec) dec.addEventListener('click', function () { qty.value = Math.max(1, qtyVal() - 1); update(); });
      if (inc) inc.addEventListener('click', function () { qty.value = Math.min(99, qtyVal() + 1); update(); });
    }
    if (letter && count) {
      letter.addEventListener('input', function () { count.textContent = letter.value.length; });
    }

    if (submit) {
      submit.addEventListener('click', function () {
        msg.textContent = '';
        if (date && date.required && !date.value) {
          msg.textContent = 'Please choose a delivery date.';
          date.focus();
          return;
        }
        if (date && date.value && date.min && date.value < date.min) {
          msg.textContent = 'Please choose a date on or after ' + date.min + '.';
          date.focus();
          return;
        }
        var q = qtyVal();
        var props = {};
        if (letter && letter.value.trim()) props[letter.dataset.prop || 'Letter'] = letter.value.trim();
        if (date && date.value) props['Delivery date'] = date.value;
        if (area && area.value) props['Deliver to'] = area.value;
        if (active.length) props['Bundle'] = active.map(function (p) { return p.dataset.lgbPack; }).join(', ');
        var items = [{ id: parseInt(idEl.value, 10), quantity: q, properties: props }];
        active.forEach(function (p) {
          p.lgbItems.forEach(function (i) {
            items.push({ id: parseInt(i.id, 10), quantity: q, properties: { 'Add-on for': root.dataset.title || '', 'Bundle': p.dataset.lgbPack } });
          });
        });
        extras().forEach(function (a) {
          items.push({ id: parseInt(a.value, 10), quantity: q, properties: { 'Add-on for': root.dataset.title || '' } });
        });
        submit.disabled = true;
        var old = submit.textContent;
        submit.textContent = 'Adding…';
        fetch(root.dataset.cartAdd, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.d.description || res.d.message || 'Could not add to bag. Please try again.');
            window.location.href = root.dataset.cart;
          })
          .catch(function (e) {
            msg.textContent = e.message;
            submit.disabled = false;
            submit.textContent = old;
          });
      });
    }

    update();
  }

  function initRelated(el) {
    if (el.dataset.ready || !el.dataset.url) return;
    el.dataset.ready = '1';
    fetch(el.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-lgb-related]');
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  function initZoom(section) {
    if (section.dataset.zoomReady) return;
    section.dataset.zoomReady = '1';
    var dialog = section.querySelector('[data-lgb-zoom-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    var img = dialog.querySelector('[data-lgb-zoom-img]');
    var last = null;
    section.querySelectorAll('[data-lgb-zoom]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        last = btn;
        img.src = btn.dataset.lgbZoom;
        img.alt = btn.dataset.alt || '';
        dialog.showModal();
      });
    });
    dialog.querySelector('[data-lgb-zoom-close]').addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
    dialog.addEventListener('close', function () { if (last) last.focus(); });
  }

  function initRotate(h, media, animate) {
    var cards = Array.prototype.slice.call(media.querySelectorAll('[data-lgb-card]'));
    var slots = Array.prototype.slice.call(media.querySelectorAll('[data-slot]'));
    if (!cards.length || !slots.length) return;
    var natural = h.classList.contains('lgb-hx--natural');
    var order = cards.map(function (c, k) { return k; });
    var wait = parseInt(h.dataset.interval, 10) || 4000;
    var timer = null;
    function place() {
      if (natural) {
        slots.forEach(function (s, k) {
          var c = cards[order[k]];
          if (!c) return;
          s.style.setProperty(k === 0 ? '--hx-ratio' : '--r', c.dataset.ratio || 1);
        });
      }
      var base = media.getBoundingClientRect();
      var rects = slots.map(function (s) { return s.getBoundingClientRect(); });
      order.forEach(function (ci, k) {
        var c = cards[ci];
        var r = rects[Math.min(k, rects.length - 1)];
        c.style.left = (r.left - base.left) + 'px';
        c.style.top = (r.top - base.top) + 'px';
        c.style.width = r.width + 'px';
        c.style.height = r.height + 'px';
        c.classList.toggle('is-main', k === 0);
        c.classList.toggle('is-small', k > 0 && k < slots.length);
        c.classList.toggle('is-parked', k >= slots.length);
        c.setAttribute('aria-hidden', k >= slots.length ? 'true' : 'false');
      });
    }
    function next() {
      order.unshift(order.pop());
      place();
    }
    function play() { if (animate && !timer) timer = setInterval(next, wait); }
    function stop() { clearInterval(timer); timer = null; }
    place();
    requestAnimationFrame(function () { requestAnimationFrame(function () { media.classList.add('is-ready'); }); });
    if (window.ResizeObserver) {
      var busy = false;
      new ResizeObserver(function () {
        if (busy) return;
        busy = true;
        requestAnimationFrame(function () { busy = false; place(); });
      }).observe(media);
    } else {
      window.addEventListener('resize', place);
    }
    media.addEventListener('mouseenter', stop);
    media.addEventListener('mouseleave', play);
    media.addEventListener('focusin', stop);
    media.addEventListener('focusout', play);
    document.addEventListener('shopify:block:select', function (e) {
      var k = cards.indexOf(e.target);
      if (k < 0) return;
      stop();
      while (order[0] !== k) order.unshift(order.pop());
      place();
    });
    document.addEventListener('shopify:block:deselect', play);
    play();
  }

  function initHero(h) {
    if (h.dataset.ready) return;
    h.dataset.ready = '1';
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var animate = h.classList.contains('lgb-hx--anim') && !still;
    var num = h.querySelector('[data-lgb-count]');
    if (num && animate) {
      var target = parseInt(num.dataset.lgbCount, 10);
      var suffix = num.dataset.suffix || '';
      if (target > 0) {
        var start = null;
        var dur = 1800;
        num.textContent = '0' + suffix;
        var step = function (t) {
          if (!start) start = t;
          var p = Math.min(1, (t - start - 900) / dur);
          if (p < 0) { requestAnimationFrame(step); return; }
          var e = 1 - Math.pow(1 - p, 3);
          num.textContent = Math.round(target * e).toLocaleString('en-US') + suffix;
          if (p < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      }
    }
    var rot = h.querySelector('[data-lgb-rot]');
    if (rot) { initRotate(h, rot, animate); return; }
    var slides = Array.prototype.slice.call(h.querySelectorAll('[data-lgb-slide]'));
    if (slides.length < 2) return;
    var i = 0;
    var timer = null;
    var wait = parseInt(h.dataset.interval, 10) || 4000;
    var natural = h.classList.contains('lgb-hx--natural');
    var box = h.querySelector('.lgb-hx__main');
    function go(n) {
      slides[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active');
      if (natural && box && slides[i].dataset.ratio) box.style.setProperty('--hx-ratio', slides[i].dataset.ratio);
    }
    function play() { if (!timer) timer = setInterval(function () { go(i + 1); }, wait); }
    function stop() { clearInterval(timer); timer = null; }
    var main = h.querySelector('.lgb-hx__main');
    if (main) {
      main.addEventListener('mouseenter', stop);
      main.addEventListener('mouseleave', play);
      main.addEventListener('focusin', stop);
      main.addEventListener('focusout', play);
    }
    document.addEventListener('shopify:block:select', function (e) {
      var k = slides.indexOf(e.target);
      if (k > -1) { stop(); go(k); }
    });
    document.addEventListener('shopify:block:deselect', play);
    if (!still) play();
  }

  function initVideos(sec) {
    if (sec.dataset.ready) return;
    sec.dataset.ready = '1';
    var n = parseInt(getComputedStyle(sec).getPropertyValue('--vid-show-m'), 10) || 4;
    var style = document.createElement('style');
    style.textContent = '@media (max-width:749px){#' + (sec.id || 'videos') + ':not(.is-all) .lgb-videos__item:nth-child(n+' + (n + 1) + '){display:none}#' + (sec.id || 'videos') + ':not(.is-all) .lgb-videos__item:nth-child(-n+' + n + '){display:flex}}';
    sec.appendChild(style);
    var dialog = sec.querySelector('[data-lgb-vid-dialog]');
    var stage = sec.querySelector('[data-lgb-vid-stage]');
    var last = null;
    sec.querySelectorAll('[data-lgb-vid-all]').forEach(function (b) {
      b.addEventListener('click', function () {
        sec.classList.add('is-all');
        var menu = sec.querySelector('.lgb-videos__menu');
        if (menu) menu.removeAttribute('open');
        var more = sec.querySelector('.lgb-videos__more');
        if (more) more.hidden = true;
      });
    });
    sec.querySelectorAll('[data-lgb-vid-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tpl = btn.parentNode.querySelector('[data-lgb-vid-player]');
        if (!tpl || !dialog) return;
        last = btn;
        stage.innerHTML = '';
        stage.appendChild(tpl.content.cloneNode(true));
        if (dialog.showModal) dialog.showModal(); else dialog.setAttribute('open', '');
        var v = stage.querySelector('video');
        if (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      });
    });
    function close() { if (dialog.open) dialog.close(); }
    if (dialog) {
      dialog.addEventListener('close', function () { stage.innerHTML = ''; if (last) last.focus(); });
      dialog.addEventListener('click', function (e) { if (e.target === dialog) close(); });
      var c = sec.querySelector('[data-lgb-vid-close]');
      if (c) c.addEventListener('click', close);
    }
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-lgb-videos]').forEach(initVideos);
    scope.querySelectorAll('[data-lgb-hero]').forEach(initHero);
    if (scope.matches && scope.matches('[data-lgb-hero]')) initHero(scope);
    scope.querySelectorAll('[data-lgb-gallery]').forEach(initGallery);
    scope.querySelectorAll('[data-lgb-bundle]').forEach(initBundle);
    scope.querySelectorAll('[data-lgb-related]').forEach(initRelated);
    scope.querySelectorAll('.lgb-steps').forEach(initZoom);
    if (scope.classList && scope.classList.contains('lgb-steps')) initZoom(scope);
  }

  function boot() {
    initHeader(document);
    init(document);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
